import React, { useEffect, useState } from "react";
import PageTableLayout from "../../components/Pagetablelayout";
import axios from "axios";
import { Space, Button, Modal, Form, Input, Select, Switch, Row, Col } from "antd";

export default function CitiesPage() {
  const [cities, setCities] = useState([]);
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingCity, setEditingCity] = useState(null);
  const [form] = Form.useForm();

  const token = localStorage.getItem("jwt"); // ✅ match AdminLogin storage key

  const fetchCities = async () => {
    setLoading(true);
    try {
      const res = await axios.get("https://mdgholidaydreams.com/api/cities", {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      setCities(res.data);
    } catch (err) {
      console.error("Fetch cities failed:", err);
    }
    setLoading(false);
  };

  const fetchCountries = async () => {
    try {
      const res = await axios.get("https://mdgholidaydreams.com/api/countries", {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      setCountries(res.data);
    } catch (err) {
      console.error("Fetch countries failed:", err);
    }
  };

  useEffect(() => {
    fetchCities();
    fetchCountries();
  }, []);

  const handleAdd = () => {
    setEditingCity(null);
    form.resetFields();
    setIsModalVisible(true);
  };

  const handleEdit = (record) => {
    setEditingCity(record);
    form.setFieldsValue({
      name: record.name,
      code: record.code,
      country_id: record.country_id,
      active: record.active,
      image_url: record.image_url,
      caption: record.caption,
      color: record.color,
      featured_on_homepage: !!record.featured_on_homepage,
      featured_destination: !!record.featured_destination,
    });
    setIsModalVisible(true);
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const payload = {
        ...values,
        featured_on_homepage: values.featured_on_homepage ? 1 : 0,
        featured_destination: values.featured_destination ? 1 : 0,
      };

      if (editingCity) {
        await axios.put(`https://mdgholidaydreams.com/api/cities?id=${editingCity.id}`, payload, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
      } else {
        await axios.post("https://mdgholidaydreams.com/api/cities", payload, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
      }

      form.resetFields();
      setIsModalVisible(false);
      setEditingCity(null);
      fetchCities();
    } catch (err) {
      console.error(err);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setEditingCity(null);
    form.resetFields();
  };

  // Table view stays exactly as before — no image_url/caption/color/featured_on_homepage
  // columns here, those only live in the create/edit form per design.
  const columns = [
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Code", dataIndex: "code", key: "code" },
    { title: "Country", dataIndex: "country_name", key: "country_name" },
    {
      title: "Active",
      dataIndex: "active",
      key: "active",
      render: active => (active ? "Active" : "Inactive"),
    },
    { title: "Created By", dataIndex: "created_by", key: "created_by" },
    { title: "Updated By", dataIndex: "updated_by", key: "updated_by" },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button onClick={() => handleEdit(record)}>Edit</Button>
          <Button
            danger
            onClick={() =>
              axios.patch(`https://mdgholidaydreams.com/api/cities?id=${record.id}`, {}, {
                headers: token ? { Authorization: `Bearer ${token}` } : {},
              }).then(fetchCities)
            }
          >
            Deactivate
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <>
      <PageTableLayout
        breadcrumb={["Admin", "Cities"]}
        title="Manage Cities"
        addButtonLabel="Add City"
        onAdd={handleAdd}
        columns={columns}
        dataSource={cities}
        loading={loading}
        onRefresh={fetchCities}
      />

      <Modal
        title={editingCity ? "Edit City" : "Add New City"}
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Save"
        width={700}
      >
        <Form form={form} layout="vertical" initialValues={{ active: 1, featured_on_homepage: false, featured_destination: false }}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="City Name"
                rules={[{ required: true, message: "Please enter a city name" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="code"
                label="City Code"
                rules={[{ required: true, message: "Please enter a city code" }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="country_id"
                label="Country"
                rules={[{ required: true, message: "Please select a country" }]}
              >
                <Select placeholder="Select country">
                  {countries.map(c => (
                    <Select.Option key={c.id} value={c.id}>
                      {c.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="active"
                label="Status"
                rules={[{ required: true, message: "Please select status" }]}
              >
                <Select placeholder="Select status">
                  <Select.Option value={1}>Active</Select.Option>
                  <Select.Option value={0}>Inactive</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          {/* Homepage slider fields — only used by the public Hero slider, not shown in the table. */}
          <Row gutter={16} style={{ borderTop: "1px solid #f0f0f0", paddingTop: 16, marginTop: 8 }}>
            <Col span={24}>
              <div style={{ fontSize: 12, color: "#8c8c8c", marginBottom: 8, fontWeight: 600, letterSpacing: 0.5 }}>
                HOMEPAGE SLIDER (shown on the public site's hero banner)
              </div>
            </Col>
            <Col span={24}>
              <Form.Item name="image_url" label="Slider Image URL">
                <Input placeholder="https://..." />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item name="caption" label="Slider Caption">
                <Input placeholder="e.g. Where turquoise waters kiss powder-white sands" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="color"
                label="Accent Color"
                rules={[{ pattern: /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/, message: "Use a hex color like #1A9ED4" }]}
              >
                <Input placeholder="#1A9ED4" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="featured_on_homepage" label="Show in Homepage Slider" valuePropName="checked">
                <Switch />
              </Form.Item>
            </Col>
          </Row>

          {/* Explore destinations grid — a separate section of the homepage, independent of the slider. */}
          <Row gutter={16} style={{ borderTop: "1px solid #f0f0f0", paddingTop: 16, marginTop: 8 }}>
            <Col span={24}>
              <div style={{ fontSize: 12, color: "#8c8c8c", marginBottom: 8, fontWeight: 600, letterSpacing: 0.5 }}>
                EXPLORE THE ISLANDS (shown as a destination card on the homepage, max 3 displayed)
              </div>
            </Col>
            <Col span={24}>
              <Form.Item name="featured_destination" label="Show in 'Explore the Islands'" valuePropName="checked">
                <Switch />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}